module.exports = __webpack_public_path__ + "static/img/joinus.0eda066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/joinus.jpg
// module id = MfV2
// module chunks = 1